module.exports = __webpack_public_path__ + "img/QuotationPriceHistories.41864f71.svg";